import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import HipobuySpreadsheetGuide from "@/pages/articles/hipobuy-spreadsheet-guide/page";
import HipobuySpreadsheetPage from "@/pages/platforms/hipobuy-spreadsheet/page";
import KakobuySpreadsheetPage from "@/pages/platforms/kakobuy-spreadsheet/page";
import CssbuySpreadsheetPage from "@/pages/platforms/cssbuy-spreadsheet/page";
import SuperbuySpreadsheetPage from "@/pages/platforms/superbuy-spreadsheet/page";
import OopbuySpreadsheetPage from "@/pages/platforms/oopbuy-spreadsheet/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <HipobuySpreadsheetGuide />,
  },
  {
    path: "/hipobuy-spreadsheet",
    element: <HipobuySpreadsheetPage />,
  },
  {
    path: "/kakobuy-spreadsheet",
    element: <KakobuySpreadsheetPage />,
  },
  {
    path: "/cssbuy-spreadsheet",
    element: <CssbuySpreadsheetPage />,
  },
  {
    path: "/superbuy-spreadsheet",
    element: <SuperbuySpreadsheetPage />,
  },
  {
    path: "/oopbuy-spreadsheet",
    element: <OopbuySpreadsheetPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;